import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { StyledIcon } from '../general/Icon'
import { desktop } from '../../styles/media'

const RadioAlternative = ({ clearable, disabled, icon, label, name, onChange, orientation, radioId, small, transparent, title, value }) => {
	const checked = name === value

	const onClick = () => {
		if (disabled) return

		if (checked && clearable) {
			onChange('')
		} else {
			onChange(name)
		}
	}

	return (
		<StyledRadioAlternative
			checked={checked}
			disabled={disabled}
			orientation={orientation}
			onClick={onClick}
			label={label}
			transparent={transparent}
			small={small}
			data-tooltip={title}
			data-tooltip-location="bottom"
		>
			<Input
				type="radio"
				name={radioId}
				onChange={() => {}}
				value={name}
				checked={checked}
				label={label}
				disabled={disabled}
			/>
			{icon && icon}
			{label && label}
		</StyledRadioAlternative>
	)
}

RadioAlternative.propTypes = {
	clearable: PropTypes.bool,
	disabled: PropTypes.bool,
	icon: PropTypes.any,
	label: PropTypes.any,
	name: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.number
	]).isRequired,
	onChange: PropTypes.func,
	orientation: PropTypes.string,
	radioId: PropTypes.string,
	value: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.number
	])
}

RadioAlternative.defaultProps = {
	clearable: true,
	disabled: false,
	label: null,
	icon: null,
	onChange: () => null,
	orientation: 'column',
	radioId: null,
	small: false,
	value: null
}

export const StyledRadioAlternative = styled.div`
	align-items: center;
	display: inline-flex;
	cursor: default;

	background: ${props => props.transparent ? 'rgba(0, 0, 0, 0.7)' : props.theme.background};
	border: 0;
	border-radius: 3px;
	color: ${props => props.transparent ? 'rgba(255, 255, 255, 0.5)' : props.theme.textVeryLight};

	font-size: 0.9rem;
	padding: 0.5rem 0.75rem;
	user-select: none;
	white-space: nowrap;

	svg {
		height: 16px;
		width: 16px;
	}

	${props => props.small && `
		font-family: ${props.theme.fontMonospace};
		font-size: 0.8rem;
		font-weight: bold;
		padding: 0.15rem 0.5rem;

		svg {
			height: 12px;
			width: 12px;
		}
	`}

	${props => props.checked && `
		background: ${props.transparent ? 'rgba(255, 255, 255, 0.7)' : '#444'};
		color: ${props.transparent ? 'rgba(0, 0, 0, 1)' : '#EEE'};
	`}

	${props => props.orientation === 'column' && `
		margin-bottom: 1px;
	`}

	${props => props.label && `
		${StyledIcon} {
			margin-right: 0.4rem;
		}
	`}

	& + & {
		margin-left: 1px;
	}

	${props => props.disabled && `
		background: ${props.theme.backgroundDisabled};
		color: ${props.theme.textVeryLight};
		cursor: not-allowed;

		input {
			opacity: 0.5;
		}
	`}

	${desktop`
		${props => !props.disabled && `
			&:hover {
				color: ${props.checked ? (props.transparent ? 'rgba(0, 0, 0, 1)' : '#EEE') : props.theme.textLight};
			}
		`}
	`}
`

const Input = styled.input`
	display: none;
`

export default RadioAlternative
